import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// reactstrap components
import { Input, FormGroup, Form, Label, Row, Col, Button } from 'reactstrap';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { actionEditAuthEmail, actionGetUpdateRequests } from 'store/actions/usersActions';
import { useTranslate } from 'react-translate';
// #ux-redesign: SweetAlert → ConfirmDialog DS
import { ConfirmDialog } from 'components/ds';

const InfoIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);

const CredentialsForm = () => {
  const t = useTranslate('credentials');
  const user = useSelector((state) => state.userReducer);

  const { activeRequests } = useSelector((state) => state.userReducer);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingData, setPendingData] = useState(null);

  const dispatch = useDispatch();

  const emailRex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const userSchema = yup.object().shape({
    new_auth_email: yup
      .string()
      .matches(emailRex, t('error-email-invalid'))
      .required(t('error-email-required')),
    auth_email_confirm: yup
      .string()
      .oneOf([yup.ref('new_auth_email'), null], t('error-required-reEmail')),
    confirm_password: yup.string().required(t('error-required-password')).min(6, t('error-required-length')),
  });

  const { register, handleSubmit, errors } = useForm({
    validationSchema: userSchema,
    mode: 'onChange',
  });

  const onEmailChange = (e) => {
    e.target.value = e.target.value.toLowerCase();
  }

  const onSubmit = (data) => {
    setPendingData(data);
    setConfirmOpen(true);
  };

  const onConfirm = () => {
    if (pendingData) dispatch(actionEditAuthEmail(pendingData.new_auth_email, pendingData.confirm_password));
    setConfirmOpen(false);
    setPendingData(null);
  };

  useEffect(() => {
    dispatch(actionGetUpdateRequests());
  }, []);

  return (
    <div className="setting-section">
      <ConfirmDialog
        isOpen={confirmOpen}
        title={t('are-you-sure')}
        confirmLabel={t('btn-yes')}
        cancelLabel={t('btn-no')}
        variant="primary"
        onConfirm={onConfirm}
        onCancel={() => {
          setConfirmOpen(false);
          setPendingData(null);
        }}
      />

      <h5 className="general-card-subtitle">{t('login-email')}</h5>

      <Label>{t('default-auth-email')}</Label>
      <Input type="text" disabled name="default_auth_email" defaultValue={user.auth_email} />

      {activeRequests && activeRequests.length ? <>
        <div className="settings-info-label">
          <i className="fa fas icon-hourglass-1"></i>
          <span>{t("email-update-pending", {email: activeRequests[0].new_value})}</span>
        </div>
      </> : <></>}

      <hr/>


      <h5 className="general-card-subtitle no-line">{t('change-credentials')}</h5>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>

          <Col sm="12" md="4">
            <Label>{t('new-auth-email')}</Label>
            <FormGroup
              className={`has-label ${errors.new_auth_email ? 'has-danger' : ''}`}
            >
              <Input type="text" innerRef={register} name="new_auth_email" onChange={(e) => {onEmailChange(e);}} />
            </FormGroup>
          </Col>

          <Col sm="12" md="4">
            <Label>{t('confirm-auth-email')}</Label>
            <FormGroup
              className={`has-label ${errors.auth_email_confirm ? 'has-danger' : ''}`}
            >
              <Input 
              type="text" 
              innerRef={register} 
              name="auth_email_confirm"
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="4">
            <Label>{t('confirm-password')}</Label>
            <FormGroup
              className={`has-label ${errors.confirm_password ? 'has-danger' : ''}`}
            >
              <Input 
                type="password" 
                innerRef={register} 
                name="confirm_password"
              />
            </FormGroup>
          </Col>


            <Col>
              <div className="settings-info-label">
                <span className="ds-info-icon">
                  <InfoIcon />
                </span>
                <span>{t("email-change-description")}</span>
              </div>
            </Col>

          

          <Col sm="12">
            <Button
              className="float-right"
              color="info"
              type="submit"
              size="sm"
            >
              {t('save-button')}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CredentialsForm;
